import { render, staticRenderFns } from "./integralWithdrawal.vue?vue&type=template&id=3696f7ba&scoped=true"
import script from "./integralWithdrawal.vue?vue&type=script&lang=js"
export * from "./integralWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./integralWithdrawal.vue?vue&type=style&index=0&id=3696f7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696f7ba",
  null
  
)

export default component.exports